import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListViewIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 23 13",
	style: { enableBackground: "new 0 0 23 13" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	    .list-icon-st0{fill:currentColor;}\n    "
	}), /* @__PURE__ */ _jsx("path", {
		className: "list-icon-st0",
		d: "M22.375 2.87492H5.45833V0.458252H22.375V2.87492ZM22.375 7.70825H5.45833V5.29158H22.375V7.70825ZM22.375 12.5416H5.45833V10.1249H22.375V12.5416ZM3.04167 12.5416H0.625V10.1249H3.04167V12.5416ZM3.04167 0.458252V2.87492H0.625V0.458252H3.04167ZM3.04167 7.70825H0.625V5.29158H3.04167V7.70825Z"
	})]
});
export default SvgListViewIcon;
